// import React, { useEffect } from "react";
// import PropTypes from "prop-types";
// import { Border, CoachProfileContainer } from "./styles";
// import SkeletonLoder from "../common/skeletonLoder";
// import LazyImage from "../common/LazyImage/LazyImage";
// import { ImageUrl } from "../../utils/constants";
// import { withTranslation } from "react-i18next";
// import { withRouter } from "react-router-dom";
// import parse from 'react-html-parser';
//import { NewViewProfileIcon } from "../../utils/icons";

// const CoachProfile = ({coachDetail,history}) => {
  
//   useEffect(() => {}, []);

//   return (
//     <>
//       {!coachDetail ? (
//         <React.Fragment>
//           {" "}
//           <SkeletonLoder width={"1248px"} height={"280px"}></SkeletonLoder>
//         </React.Fragment>
//       ) : (
//         <CoachProfileContainer>
//           {/* <div className="coachProfile">
//             <div className="coachProfileImageContainer">
//               <LazyImage
//                 style={{ width: "120px", height: "120px", borderRadius: "50%" }}
//                 className="coachProfileImage"
//                 src={ImageUrl + "/" + coachDetail?.profile_image}
//               />{" "}
//               <div className="coachProfileDetails">
//                 <div className="coachProfileName">
//                   Coach: {coachDetail?.name}
//                 </div>
//                 <div className="coachProfileEducation">
//                   {coachDetail?.education}
//                 </div>
//                 <div className="coachInterest">
//                   {coachDetail?.interested_tags?.map((tag) => (
//                     <div key={tag} className="coachInterestTag">
//                       {tag.category_name}
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//             <div className="coachProfileDetails" style={{width:"120px"}}>
//               <span className="viewProfile" onClick={() =>history.push(`/events/coach/${coachDetail.id}`)}>View Profile</span>
//             </div>
//           </div> */}
//           <div className="coachProfile">
//             <div className="coachProfileImageContainer">
//               <LazyImage
//                 style={{ width: "120px", height: "120px", borderRadius: "50%" }}
//                 className="coachProfileImage"
//                 src={ImageUrl + "/" + coachDetail?.profile_image}
//               />
//               <div className="coachProfileDetails">
//                 <div className="coachProfileName">
//                   Coach: {coachDetail?.name}
//                 </div>
//                 <div className="coachProfileEducation">
//                   {coachDetail?.education}
//                 </div>
//                 <div className="coachInterest">
//                   {coachDetail?.interested_tags?.map((tag) => (
//                     <div key={tag} className="coachInterestTag">
//                       {tag.category_name}
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//             <div
//               className="viewProfileLink"
//               onClick={() => history.push(`/events/coach/${coachDetail.id}`)}
//             >
//               <NewViewProfileIcon />
//               <span>View profile</span>
//             </div>
//           </div>
//           <Border
//             style={{
//               background: "rgba(0, 92, 135, 0.10)",
//               marginLeft: "140px",
//             }}
//           />
//           <div className="coachProfileBio">
//             <div>{parse(coachDetail?.about)}</div>
//           </div>
//         </CoachProfileContainer>
//       )}
//     </>
//   );
// };

// CoachProfile.propTypes = {
//   coachDetail: PropTypes.object.isRequired,
//   history: PropTypes.object,
// };

// export default withRouter((withTranslation()(CoachProfile))
// );




import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import parse from 'react-html-parser';
// import { NewViewProfileIcon } from "../../utils/icons";
import SkeletonLoder from "../common/skeletonLoder";
//import LazyImage from "../common/LazyImage/LazyImage";
import { ImageUrl } from "../../utils/constants";
import {
  CoachWrapper,
  ImageBackground,
  CoachDetailCard
} from "./styles"; 
import { CommonButtonBorder } from "../common/commonStyles";


const CoachProfile = ({ coachDetail, t, history, showViewProfileLink = true,AdminView }) => {
  const getCoachData = coachDetail; 
  if (!coachDetail) {
    return <SkeletonLoder width={"1248px"} height={"280px"} />;
  }
  return (
  
    <CoachWrapper>
      <div className="image-background">
        <ImageBackground>
          <div className="imageCard">
            <div className="image">
              <img src={` ${ImageUrl}/${getCoachData?.profile_image} `} alt={getCoachData?.name} />
            </div>
          </div>
          <div className="edu">
            <div className="coach-identity">
              <div className="name">{getCoachData?.name}</div>
              <div className="education">{getCoachData?.education}</div>
            </div>

            
          </div>
        </ImageBackground>
      </div>
      <div className="details">
        <CoachDetailCard>
          <div className="categoryWrapper">
            <div className="tags-list">
              {getCoachData?.interested_tags?.map((data, index) => (
                <div className="category" key={index}>{t(data?.category_name)}</div>
              ))}
            </div>
            {showViewProfileLink ? (<CommonButtonBorder className="viewProfileLink" onClick={() => history.push( AdminView ==="admin" ? `/company/events/coach/${getCoachData.id}`   :`/events/coach/${getCoachData.id}`)}>{t("View profile")}</CommonButtonBorder>):null}
            {/* {showViewProfileLink && (
              <div 
                className="viewProfileLink" 
                onClick={() => history.push( AdminView ==="admin" ? `/company/events/coach/${getCoachData.id}`   :`/events/coach/${getCoachData.id}`)}
              >
                <NewViewProfileIcon />
                <span>{t("View profile")}</span>
              </div>
            )} */}
          </div>
          <div className="bio">{parse(getCoachData?.about || '')}</div>
        </CoachDetailCard>
      </div>
    </CoachWrapper>
  );
};

CoachProfile.propTypes = {
  coachDetail: PropTypes.object.isRequired,
  history: PropTypes.object,
  t: PropTypes.func.isRequired,
  showViewProfileLink: PropTypes.bool,
  AdminView: PropTypes.string,
};

export default withRouter(withTranslation()(CoachProfile));